import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const HiddenLabelWrapper = styled.div`
    &&& label {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
    }    
`;
